export default __webpack_public_path__ + "static/media/RealCase-mobile-en.442763a6.jpg";